import React from 'react';
import { UrlMatcher } from '@kyruus/rich-text/Renderer';
import { detectRichText } from '../utils';
import { LocationDescriptionRichText } from './styles';

interface DescriptionProps {
  locationDescription: string;
  autolink?: {
    enabled?: boolean;
    customTLDs?: string[];
  };
}
export const Description = ({
  locationDescription,
  autolink: { enabled = true, customTLDs = [] } = {}
}: DescriptionProps) => {
  const isRichText = detectRichText(locationDescription);
  return (
    <LocationDescriptionRichText
      content={locationDescription}
      tagName={isRichText ? 'div' : 'p'}
      disableDefaultMatchers={true}
      matchers={enabled ? [new UrlMatcher('url', { customTLDs })] : []}
      newWindow={true}
    />
  );
};
